module.exports = __webpack_public_path__ + "static/media/Uh-sung-cho.8f98b553.jpg";